import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const session_id = params.get('session_id');
    if (!session_id) {
      nav('/login');
      return;
    }
    const role = sessionStorage.getItem('signup_role') || 'buyer';
    sessionStorage.removeItem('signup_role');

    googleExchange(session_id, role).then((user) => {
      window.history.replaceState(null, '', window.location.pathname);
      const roleLabel = user.role === 'seller' ? 'vendedor' : user.role === 'admin' ? 'administrador' : 'comprador';
      toast.success(`Bienvenido, ${user.name}. Cuenta de ${roleLabel}.`);
      if (user.role === 'admin') nav('/admin');
      else if (user.role === 'seller') nav('/vendedor');
      else if (user.role === 'logistics') nav('/logistica');
      else nav('/');
    }).catch(() => {
      toast.error('Error al iniciar sesión con Google');
      nav('/login');
    });
  }, [googleExchange, nav]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-slate-600 font-mono text-sm">Procesando autenticación...</div>
    </div>
  );
}
